import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M5.60005 10.9999V2.9999M5.60005 10.9999C5.60005 11.8836 4.8837 12.5999 4.00005 12.5999H2.40005C1.51639 12.5999 0.800049 11.8836 0.800049 10.9999V2.9999C0.800049 2.11625 1.51639 1.3999 2.40005 1.3999H4.00005C4.8837 1.3999 5.60005 2.11625 5.60005 2.9999M5.60005 10.9999C5.60005 11.8836 6.31639 12.5999 7.20005 12.5999H8.80005C9.6837 12.5999 10.4 11.8836 10.4 10.9999M5.60005 2.9999C5.60005 2.11625 6.31639 1.3999 7.20005 1.3999H8.80005C9.6837 1.3999 10.4 2.11625 10.4 2.9999M10.4 10.9999V2.9999M10.4 10.9999C10.4 11.8836 11.1164 12.5999 12 12.5999H13.6C14.4837 12.5999 15.2 11.8836 15.2 10.9999V2.9999C15.2 2.11625 14.4837 1.3999 13.6 1.3999H12C11.1164 1.3999 10.4 2.11625 10.4 2.9999" />
  </svg>
);
